export default "__VITE_ASSET__BHLKWBfE__"